import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { BrandedErrorPage } from './BrandedErrorPage';

/**
 * router.tsx's top-level errorElement. Without this, an unhandled loader/
 * render error anywhere in the route tree falls through to React Router's
 * own default error screen — unstyled, no branding, a raw stack trace.
 * This is the router-level counterpart to ErrorBoundary.tsx, which only
 * catches React render errors, not routing/loader errors.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <BrandedErrorPage
        code={String(error.status)}
        title={error.status === 404 ? 'Page not found' : 'Something went wrong'}
        message={
          error.status === 404
            ? "The page you're looking for doesn't exist, or may have moved."
            : "We hit a snag loading this page. Try again, or head back home."
        }
      />
    );
  }

  const detail = error instanceof Error ? `${error.message}\n\n${error.stack ?? ''}` : undefined;

  return (
    <BrandedErrorPage
      title="Something went wrong"
      message="An unexpected error occurred. Try reloading, or head back home."
      detail={detail}
    />
  );
}
